// [목적] open redirect 방어 — returnTo/next 등 외부 입력 경로를 same-origin 내부 경로로만 허용
// [이유] auth-wave3-4 보안 Block(High-1): FE 가 returnTo/next 를 sanitize 없이 navigate 에 사용 →
//         `/onboarding?returnTo=//evil.com`, `/auth/callback/kakao?next=//evil.com` 등 외부 리다이렉트 가능.
//         BE auth.controller.ts sanitizeNextPath 와 동등 규칙을 FE 소비 경계에서도 강제한다.
// [사이드 이팩트] 모든 returnTo/next navigate 소비 지점이 본 헬퍼를 거쳐야 함(useAuth/AuthProvider/OAuthCallbackPage).
//                 위반(외부 URL·위험 스킴·제어문자) 시 fail-closed 로 '/' 폴백.
// [수정 시 고려사항] 규칙 변경 시 BE auth.controller.ts:399 sanitizeNextPath 와 동기 유지 + safeRedirect.test.ts 갱신.
//                   허용 경로는 leading 단일 '/' 로 시작하는 same-origin 상대 경로뿐.
//                   제어문자 검사는 codePoint 비교(charCodeAt < 0x20)로 수행 — 소스에 raw 제어바이트 금지.

/** 위험 스킴 — 경로 어디에도 포함되면 거부 (대소문자 무시) */
const DANGEROUS_SCHEME = /(javascript|data|vbscript):/i;

/** 제어문자(U+0000~U+001F: NUL/탭/개행 등) 포함 여부 — 정규식 raw 제어바이트 회피 위해 codePoint 비교 */
function hasControlChar(s: string): boolean {
  for (let i = 0; i < s.length; i += 1) {
    if (s.charCodeAt(i) < 0x20) return true;
  }
  return false;
}

/**
 * [목적] next/returnTo 경로 sanitize — same-origin 내부 경로만 허용, 위반 시 '/' 폴백
 * [이유] open redirect 방어 (BE sanitizeNextPath 와 동등 규칙)
 * [사이드 이팩트] 없음(순수 함수). 입력이 안전 경로면 그대로, 아니면 '/' 반환
 * [수정 시 고려사항] leading '//'(protocol-relative)·'/\\'(백슬래시)·스킴·제어문자·비-'/' 시작 모두 거부
 */
export function sanitizeNextPath(next: string | null | undefined): string {
  if (typeof next !== 'string') return '/';
  const trimmed = next.trim();
  if (
    trimmed === '' ||
    !trimmed.startsWith('/') || // leading '/' 필수 (절대 URL·상대명 거부)
    trimmed.startsWith('//') || // protocol-relative (//evil.com) 거부
    trimmed.startsWith('/\\') || // 백슬래시 우회 (/\evil.com) 거부
    DANGEROUS_SCHEME.test(trimmed) || // javascript:/data:/vbscript: 거부
    hasControlChar(trimmed) // 개행/탭 등 제어문자 거부
  ) {
    return '/';
  }
  return trimmed;
}
